import React from 'react';

import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';
import { useProjectTreeStore } from 'store/projectContract.store';

import { cardsDataQueryKey } from 'api/queries/cardsData.query';
import { listCardsDataQueryKey } from 'api/queries/getListFilteredCards.query';
import { useQueryVersionList } from 'api/queries/getVersionListByContractId.query';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';

import ColumnsBoard from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/ColumnsBoard/ColumnsBoard';
import { MobilePageContainer } from 'components/Mobile/components/PageContainer/pageContainer.mobile';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import classes from 'components/Mobile/pages/activities/activities.mobile.module.scss';

export const ActivitiesMobile = () => {
    useFullStoryPageView({ pageName: `${mobileAppConfig.activities.title} (mobile)` });

    const globalFilterData = useGlobalFilterDataStore((state) => state.globalFilterData);
    const contract = useProjectTreeStore((state) => state.contract);
    const project = useProjectTreeStore((state) => state.project);
    const { data } = useQueryVersionList({ ids: [-1], contractId: contract?.id });

    const latestVersion = data ? data[0] : undefined;
    const latestVersionId = latestVersion && latestVersion.versionDbId;

    return (
        <MobilePageContainer className={classes.columnsBoardLayout}>
            {latestVersionId && (
                <ColumnsBoard
                    globalFilterData={globalFilterData}
                    projectId={project?.id}
                    contractId={contract?.id}
                    latestVersionId={latestVersionId}
                />
            )}
            <MainCardRoutingModal queryKeys={[cardsDataQueryKey, listCardsDataQueryKey, 'CountersData', 'boardInit']} />
        </MobilePageContainer>
    );
};
